import AreaSelect from "./index.vue";

AreaSelect.install = Vue => Vue.component(AreaSelect.componentName, AreaSelect);

export default AreaSelect;
